"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTradeupCreditOfferSchema = void 0;
exports.UpdateTradeupCreditOfferSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    definitions: {
        OfferStatusUpdate: {
            properties: {
                newStatus: {
                    type: "string"
                },
                offerName: {
                    type: "string"
                },
                previousStatus: {
                    type: "string"
                },
                quantity: {
                    type: "number"
                }
            },
            required: [
                "newStatus",
                "offerName",
                "previousStatus",
                "quantity"
            ],
            type: "object"
        }
    },
    properties: {
        offers: {
            items: {
                $ref: "#/definitions/OfferStatusUpdate"
            },
            type: "array"
        },
        sonosId: {
            type: "string"
        }
    },
    required: [
        "offers",
        "sonosId"
    ],
    type: "object"
};
//# sourceMappingURL=data:application/json;base64,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